import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('HotelInventoryService', HotelInventoryService);

  HotelInventoryService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'HotelInventoryModalService',
  ];

  function HotelInventoryService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    HotelInventoryModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'hotel_inventories';

    var service = {
      getHotelInventory: getHotelInventory,
      saveHotelInventory: saveHotelInventory,
      saveHotelInventoriesByDates: saveHotelInventoriesByDates,
      openHotelInventoryModal: openHotelInventoryModal,
    };

    return service;

    ////////////////

    function getHotelInventory(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = {};
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }

        /*function(response){
                    service.items = response.data;
                }, function(err) { }*/
      );
    }

    function saveHotelInventory(item) {
      function success(response) {
        utils._successMsg($translate('INVENTORY_UPDATED'));
        if (!item.id) {
          // New
          item.id = response.data.id;
        }

        item.total_availability = response.data.total_availability;

        utils.itemListChanged(item.id);

        return true;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);
        return false;
      }

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      return RestResource.request(method, url, item, success, failure);
    }

    function saveHotelInventoriesByDates(item) {
      function success() {
        utils._successMsg($translate('INVENTORY_UPDATED'));
        return true;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);
        return false;
      }

      var url = apiUrl + '/change_total_by_dates';

      return RestResource.request('post', url, item, success, failure);
    }

    function openHotelInventoryModal(item, successCallback) {
      HotelInventoryModalService.openHotelInventoryModal(item, successCallback);
    }
  }
})();
